import React, { useEffect } from "react";
import { useHistory } from "react-router-dom"

// reactstrap components
import {
  Card,
  CardBody,
  Row,
  Col,
  CustomInput,
} from "reactstrap";

import {
  Box,
  Button,
  TableContainer,
} from "@mui/material"

import SweetAlert from "react-bootstrap-sweetalert";
import { ToastContainer } from "react-toastify";
import notification from "assets/ringtone.ogg";

import TimerRow from "components/TimerTable/TimerRow"
import TimerTable from "components/TimerTable/TimerTable"
import FATETable from "components/FATETable/FATETable"
import LanguageDependentText from "components/TimerTable/LanguageDependentText";
import { useHuntTrackerContext } from "tracker-context";

import { SocketIO } from "sessions/socket";
import { HuntTimers } from "sessions/databaseStorage";
import { SessionConfigs } from "sessions/sessionState";
import { dataCenters } from "sessions/resources/datacenters";

const Timer = (props) => {
  const history = useHistory();
  const [alert, setAlert] = React.useState(null);
  const audioRef = React.createRef();

  const [fateInfo, setFateInfo] = React.useState([]);

  var chainInfo = {};
  chainInfo = HuntTimers.getChainInfo();

  const dataCenterTravel = async () => {
    if (props.match.params["world"]) {
      const worldKey = props.match.params["world"];
      for (var key of Object.keys(dataCenters)) {
        if (key.toLocaleLowerCase() === worldKey.toLocaleLowerCase()) {
          await SessionConfigs.setDataCenter(key);
          await SessionConfigs.syncSession();
          return;
        }

        for (var world of dataCenters[key]["Names"]) {
          if (world.toLocaleLowerCase() === worldKey.toLocaleLowerCase()) {
            await SessionConfigs.setDataCenter(key);
            await SessionConfigs.setWorldSelectOnly("fate", world);
            await SessionConfigs.syncSession();
          }
        }
      }
    }
  }

  const [loadingState, setLoadingState] = React.useState(true);
  React.useEffect(() => {
    dataCenterTravel().then(() => {
      if (SessionConfigs.getDataCenter() == "") {
        history.push("/index", {replace: true});
        return;
      };
  
      if (!HuntTimers.isSynced("FATE")) {
        SessionConfigs.queryData("/api/fetchFATETimers", {
          "QueryFATETimers": SessionConfigs.getWorldsOfDataCenter()["Names"],
          "DataCenter": SessionConfigs.getDataCenter()
        }).then((response) => {
          //console.log(response.data)
          HuntTimers.setFATETimers(response.data);
          setFateInfo(HuntTimers.getFATEInfo());
          setLoadingState(false);
        }).catch((error) => {
          console.log(error)
          if (error.response.status == 429) {
            setAlert(
              <SweetAlert
                  error style={{display: "block",marginTop: "-100px"}}
                  title="Rate Limit Hit" onConfirm={() => setAlert(null)}
                  onCancel={() => setAlert(null)} confirmBtnBsStyle="info" >
              </SweetAlert>
            );
          } else {
            setAlert(
              <SweetAlert
                  error style={{display: "block",marginTop: "-100px"}}
                  title="Unknown Error" onConfirm={() => setAlert(null)}
                  onCancel={() => setAlert(null)} confirmBtnBsStyle="info" >
              {error.response.status}
              </SweetAlert>
            );
          }
        });
      } else {
        setFateInfo(HuntTimers.getFATEInfo());
        setLoadingState(false);
      }
    })
  }, [])

  React.useEffect(() => {
    if (audioRef.current) {
      audioRef.current.volume = SessionConfigs.getAudioVolume();
    }
  }, [audioRef.current]);

  const hideDeadRef = React.useRef();
  React.useEffect(() => {
    if (document.getElementById("fate" + "HideDead") && fateInfo.length > 0) document.getElementById("fate" + "HideDead").checked = fateInfo[0].hideDead;
  }, [hideDeadRef.current])

  const toggleHiddenHunts = (type, event) => {
    HuntTimers.setHideDeadHunts(type, event.currentTarget.checked);
    HuntTimers.updateDisplayState(type);
    SessionConfigs.setHideDeadHunts(type, event.currentTarget.checked);
    updateDisplayStatus(type);
  }

  var timerConfigs = SessionConfigs.getToggleStates();
  const worlds = SessionConfigs.getWorldsOfDataCenter() ? SessionConfigs.getWorldsOfDataCenter()["Names"] : [];
  const patches = Object.keys(timerConfigs.fateConfig.patch);
  var lastClick = new Date().getTime();
  var lastClickType = "";

  const updateDisplayStatus = () => {
    setFateInfo(HuntTimers.getFATEInfo());
    const currentTime = new Date().getTime();

    for (var i = 0; i < fateInfo.length; i++) {
      const row = document.getElementById(fateInfo[i].worldName + "_" + fateInfo[i].fateName + "_Row");
      if ((fateInfo[i].displayState && (!fateInfo[i].hideDead || currentTime > fateInfo[i].expectMinTime )) == row.classList.contains("d-none")) {
        row.classList.toggle("d-none");

        for (var j in fateInfo[i].Chained) {
          const chainedRow = document.getElementById(fateInfo[i].worldName + "_" + fateInfo[i].Chained[j] + "_Row");
          if (row.classList.contains("d-none")) {
            chainedRow.classList.add("d-none");
          } else {
            chainedRow.classList.remove("d-none");
          }
        }
      }
    }
  }

  const toggleWorldState = (type, world, event) => {
    var newClick = new Date().getTime();

    if (newClick - lastClick < 300 && lastClickType == world) {
      lastClick = newClick;

      for (var i = 0; i < worlds.length; i++) {
        if (worlds[i] != world) {
          document.getElementById(type+worlds[i]).classList.remove("btn-selected");
        } else {
          document.getElementById(type+worlds[i]).classList.add("btn-selected");
        }
      }
      SessionConfigs.setWorldSelectOnly(type, world);
      HuntTimers.updateDisplayState(type);
      updateDisplayStatus(type);

    } else {
      lastClick = newClick;
      lastClickType = world;

      event.currentTarget.classList.toggle("btn-selected");
      const state = event.currentTarget.classList.contains("btn-selected");
      SessionConfigs.setWorldSelect(type, world, state);
      HuntTimers.updateDisplayState(type);
      updateDisplayStatus(type);
    }
  }
  
  const togglePatchState = (type, patch, event) => {
    var newClick = new Date().getTime();
    if (newClick - lastClick < 300 && lastClickType == patch) {
      lastClick = newClick;
      
      for (var i = 0; i < patches.length; i++) {
        if (patches[i] != patch) {
          document.getElementById(type+patches[i]).classList.remove("btn-selected");
        } else {
          document.getElementById(type+patches[i]).classList.add("btn-selected");
        }
      }
      SessionConfigs.setPatchSelectOnly(type, patch);
      HuntTimers.updateDisplayState(type);
      updateDisplayStatus(type);

    } else {
      lastClick = newClick;
      lastClickType = patch;

      event.currentTarget.classList.toggle("btn-selected");
      const state = event.currentTarget.classList.contains("btn-selected");
      SessionConfigs.setPatchSelect(type, patch, state);
      HuntTimers.updateDisplayState(type);
      updateDisplayStatus(type);
    }
  }

  return (
    <>
      <div className="content">
        {alert}
        <audio src={notification} ref={audioRef}/>
        <Row style={{marginTop: 15}}>
          <ToastContainer
              style={{width: 400}}
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop
              closeOnClick
              rtl={false}
              pauseOnFocusLoss={false}
              draggable
              pauseOnHover
            />
          <Col id={"FATECard"}>
            <Card>
              <CardBody>
                {loadingState ? null : ([
                  <Box key={"tableTitle"} pt={1} px={3} style={{display: "flex", justifyContent: "space-between"}}>
                    <LanguageDependentText header="fateTable" variant="h4"/>

                    <Box className="pull-right">
                      <CustomInput type="switch" id={"fate" + "HideDead"} onClick={(event) => toggleHiddenHunts("fate", event)} label={<LanguageDependentText header={"tableHideDead"} component="p" fontSize={15}/>} />
                    </Box>
                  </Box>,
                  <Box key={"worldSelect"} pt={1} px={3}>
                    <LanguageDependentText header="worldSelectTitle" variant="h6"/>
                  </Box>,
                  <Box key={"worldGroup"} pt={1} px={3}>
                    {worlds.map((world)=>(
                      (timerConfigs.fateConfig.world[world]) ? (
                      <Button id={"fate"+world} key={world} variant="outlined" className="btn-selected" onClick={(event) => toggleWorldState("fate", world, event)}>
                        <LanguageDependentText text={world} variant="body2" fontSize={13}></LanguageDependentText>
                      </Button>
                      ) : (
                      <Button id={"fate"+world} key={world} variant="outlined" onClick={(event) => toggleWorldState("fate", world, event)}>
                        <LanguageDependentText text={world} variant="body2" fontSize={13}></LanguageDependentText>
                      </Button> 
                    )))}
                  </Box>,
                  <Box key={"patchSelect"} pt={1} px={3}>
                    <LanguageDependentText header="patchSelectTitle" variant="h6"/>
                  </Box>,
                  <Box key={"patchGroup"} pt={1} px={3} mb={4}>
                    {patches.map((patch)=>(
                      (timerConfigs.fateConfig.patch[patch]) ? (
                      <Button id={"fate"+patch} key={patch} variant="outlined" className="btn-selected" onClick={(event) => togglePatchState("fate", patch, event)}>
                        <LanguageDependentText patchName={patch} variant="body2" fontSize={13}></LanguageDependentText>
                      </Button>
                      ) : (
                      <Button id={"fate"+patch} key={patch} variant="outlined" onClick={(event) => togglePatchState("fate", patch, event)}>
                        <LanguageDependentText patchName={patch} variant="body2" fontSize={13}></LanguageDependentText>
                      </Button> 
                    )))}
                  </Box>,
                  <Box key={"tableContent"}>
                    <TableContainer sx={{ boxShadow: "none", overflowY: "hidden" }}>
                      <FATETable bossFATEs={fateInfo} chainFATEs={chainInfo} />
                    </TableContainer>
                  </Box>
                ])}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Timer;
